import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          ><ol>
          <li>
          <p>Houet T, Verburg PH, Loveland TR. Monitoring and modelling landscape dynamics. Landsc Ecol. 2010; 25: 163-167.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Bharath A. Spatio-temporal dynamics along the terrain gradient of diverse landscape. J Environ Eng Landsc Manag. 2014; 22: 50-63.</p>
          </li>
          <li>
          <p>Bharath S, Rajan KS, Ramachandra TV. Land surface temperature responses to land use land cover dynamics. Geoinfor Geostat Overview. 2013; 1: 1000112.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Gupta N. Modelling landscape dynamics with LST in protected areas of Western Ghats, Karnataka. J Environ Manag. 2018; 206: 1253-1262.</p>
          </li>
          <li>
          <p>Vinay S, Bharath S, Bharath HA, Ramachandra TV. Hydrologic model with landscape dynamics for drought monitoring. Proceedings of the Joint International Workshop of ISPRS WG VIII/1 and WG IV/4 on Geospatial Data for Disaster and Risk Reduction; 2013 November 21st-22nd; Hyderabad, India. Bangalore: ENVironmental Information System [ENVIS], Centre for Ecological Sciences, Indian Institute of Science.</p>
          </li>
          <li>
          <p>Heald CL, Spracklen DV. Land use change impacts on air quality and climate. Chem Rev. 2015; 115: 4476-4496.</p>
          </li>
          <li>
          <p>Borrelli P, Robinson DA, Fleischer LR, Lugato E, Ballabio C, Alewell C, et al. An assessment of the global impact of 21st century land use change on soil erosion. Nat Commun. 2017; 8: 2013.</p>
          </li>
          <li>
          <p>Munroe DK, M&uuml;ller D. Issues in spatially explicit statistical land-use/cover change (LUCC) models: Examples from western Honduras and the central highlands of Vietnam. Land Use Policy. 2007; 24: 521-530.</p>
          </li>
          <li>
          <p>Bajocco S, De Angelis A, Perini L, Ferrara A, Salvati L. The impact of land use/land cover changes on land degradation dynamics: A Mediterranean case study. Environ Manag. 2012; 49: 980-989.</p>
          </li>
          <li>
          <p>Roy DP, Ju J, Kline K, Scaramuzza PL, Kovalskyy V, Hansen M, et al. Web-enabled Landsat Data (WELD): Landsat ETM+ composited mosaics of the conterminous United States. Remote Sens Environ. 2010; 114: 35-49.</p>
          </li>
          <li>
          <p>Riitters K, Wickham J, Costanza JK, Vogt P. A global evaluation of forest interior area dynamics using tree cover data from 2000 to 2012. Landsc Ecol. 2016; 31: 137-148.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Chandran MDS. Geospatial analysis of forest fragmentation in Uttara Kannada District, India. For Ecosyst. 2016; 3: 10.</p>
          </li>
          <li>
          <p>Lindenmayer DB, Fischer J. Habitat fragmentation and landscape change: An ecological and conservation synthesis. Washington: Island Press; 2013.</p>
          </li>
          <li>
          <p>Laurance WF, Delam&ocirc;nica P, Laurance SG, Vasconcelos HL, Lovejoy TE. Rainforest fragmentation kills big trees. Nature. 2000; 404: 836.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S. Carbon footprint of Karnataka: Accounting of sources and sinks. In: Carbon footprint case studies. Singapore: Springer; 2021. pp.53-92.</p>
          </li>
          <li>
          <p>Haddad NM, Gonzalez A, Brudvig LA, Burt MA, Levey DJ, Damschen EI. Experimental evidence does not support the habitat amount hypothesis. Ecography. 2017; 40: 48-55.</p>
          </li>
          <li>
          <p>Setturu B, Aithal BH, Sanna Durgappa D, Ramachandra TV. Landscape dynamics through spatial metrics. Proceedings of the India GeoSpatial Conference; 2012 February 7th-9th; Epicentre, Gurgaon, India. New Delhi: India Geospatial Forum.</p>
          </li>
          <li>
          <p>Uuemaa E, Antrop M, Roosaare J, Marja R, Mander &Uuml;. Landscape metrics and indices: An overview of their use in landscape research. Living Rev Landsc Res. 2009; 3: 1-28.</p>
          </li>
          <li>
          <p><a></a> Aithal BH, Setturu B, Durgappa S, Ramachandra TV. Effectiveness of landscape spatial metrics with reference to the spatial resolutions of remote sensing data. Proceedings of the India Conference on Geo-spatial Technologies &amp; Applications; 2012 April 12th-14th; IIT Bombay, Mumbai, India. Bangalore: Energy and Wetlands Research Group.</p>
          </li>
          <li>
          <p>Ramachandra TV, Sellers J, Bharath HA, Setturu B. Micro level analyses of environmentally disastrous urbanization in Bangalore. Environ Monit Assess. 2019; 191: 787.</p>
          </li>
          <li>
          <p>Kennedy CM, Hawthorne PL, Miteva DA, Baumgarten L, Sochi K, Matsumoto M, et al. Optimizing land use decision-making to sustain Brazilian agricultural profits, biodiversity and ecosystem services. Biol Conserv. 2016; 204: 221-230.</p>
          </li>
          <li>
          <p>Kivinen S, Kumpula T. Detecting land cover disturbances in the Lappi reindeer herding district using multi-source remote sensing and GIS data. Int J Appl Earth Obs Geoinf. 2014; 27: 13-19.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Vinay S, Tara NM, Subashchandran MD, Joshi NV. Conservation and sustainable management of local hotspots of biodiversity. In: Geospatial Infrastructure, applications and technologies: India case studies. Singapore: Springer; 2018. pp.365-383.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Vinay S. Visualisation of impacts due to the proposed developmental projects in the ecologically fragile regions-Kodagu district, Karnataka. Prog Disaster Sci. 2019; 3: 100038.</p>
          </li>
          <li>
          <p>Wang Y, Gao J, Zou C, Xu D, Wang L, Jin Y, et al. Identifying ecologically valuable and sensitive areas: A case study analysis from China. J Nat Conserv. 2017; 40: 49-63.</p>
          </li>
          <li>
          <p>Sen P. The report of the committee on identifying parameters for designating ecologically sensitive areas in India. New Delhi: Ministry of Environment and Forests, Government of India; 2000.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Rajan KS, Chandran S. Modelling the forest transition in Central Western Ghats, India. Spat Inf Res. 2017; 25: 117-130.</p>
          </li>
          <li>
          <p>Bharath S, Rajan KS, Ramachandra TV. Modeling forest landscape dynamics. Hauppauge: NOVA Science Publishers; 2021. pp.249.</p>
          </li>
          <li>
          <p>Bharath S, Ramachandra TV. Modeling landscape dynamics of policy interventions in Karnataka State, India. J Geovis Spat Anal. 2021; 5: 22.</p>
          </li>
          <li>
          <p>Pascal JP. Explanatory booklet on the forest map of south India. Sheets: Belgaum-Dharwar-Panaji, Shimoga, Mercara-Mysore. Paris: Institut Fran&ccedil;ais de Pondich&eacute;ry; 1986.</p>
          </li>
          <li>
          <p>Bernasconi M, Choirat C, Seri R. The analytic hierarchy process and the theory of measurement. Manag Sci. 2010; 56: 699-711.</p>
          </li>
          <li>
          <p>Rao KS, Sringeswara AN, Kumar D, Pulla S, Sukumar R. A digital herbarium for the flora of Karnataka. Curr Sci. 2012; 102: 1268-1271.</p>
          </li>
          <li>
          <p>Vattakaven T, George RM, Balasubramanian D, R&eacute;jou-M&eacute;chain M, Muthusankar G, Ramesh BR, et al. India biodiversity portal: An integrated, interactive and participatory biodiversity informatics platform. Biodivers Data J. 2016; 4: e10279.</p>
          </li>
          <li>
          <p>Ramachandra TV, Bharath S, Chandran MS, Joshi NV. Salient ecological sensitive regions of Central Western Ghats, India. Earth Syst Environ. 2018; 2: 15-34.</p>
          </li>
          <li>
          <p>Beinat E. Value functions for environmental management. Boston: Kluwer Academic; 1997. pp.241.</p>
          </li>
          <li>
          <p>Kattumuri R, Kruse T. Renewable technologies in Karnataka, India: Jobs potential and co-benefits. Clim Dev. 2019; 11: 124-137.</p>
          </li>
          <li>
          <p>Ramsdale JD, Balme MR, Conway SJ, Gallagher C, van Gasselt SA, Hauber E, et al. Grid-based mapping: A method for rapidly determining the spatial distributions of small features over very large areas. Planet Space Sci. 2017; 140: 49-61.</p>
          </li>
          <li>
          <p>Mehta P, Sekar KC, Bhatt D, Tewari A, Bisht K, Upadhyay S, et al. Conservation and prioritization of threatened plants in Indian Himalayan region. Biodivers Conserv. 2020; 29: 1723-1745.</p>
          </li>
          <li>
          <p>Volis S. Conservation-oriented restoration-a two for one method to restore both threatened species and their habitats. Plant Divers. 2019; 41: 50-58.</p>
          </li>
          </ol>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
